// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { apiClient } from './client';

export interface FormThemeDto {
  preset: string;
  overrides: FormThemeOverrides | null;
}

export interface FormThemeOverrides {
  inputRadius?: string;
  inputPaddingX?: string;
  inputPaddingY?: string;
  inputFontSize?: string;
  inputShadow?: string;
  labelSize?: string;
  labelWeight?: string;
  labelGap?: string;
  sectionBorder?: string;
  gap?: string;
  fontFamily?: string;
}

export interface FormThemePreset {
  id: string;
  name: string;
  description: string;
  variables: FormThemeOverrides;
}

export async function fetchFormTheme(): Promise<FormThemeDto> {
  const { data } = await apiClient.get<FormThemeDto>('/api/admin/form-theme');
  return data;
}

export async function saveFormTheme(preset: string, overrides: FormThemeOverrides | null): Promise<void> {
  await apiClient.put('/api/admin/form-theme', { preset, overrides });
}

export async function fetchFormThemePresets(): Promise<FormThemePreset[]> {
  const { data } = await apiClient.get<FormThemePreset[]>('/api/admin/form-theme/presets');
  return data;
}
